import { defineStore } from 'pinia'

export interface DownloadEntry {
    downloadKey: string
    filename: string
    expiresAt: number
}

export const useDownloadsStore = defineStore('downloads', {
    state: () => ({
        downloads: [] as DownloadEntry[],
    }),

    getters: {
        hasDownloads: (state): boolean => state.downloads.length > 0,
    },

    actions: {
        async init(): Promise<void> {
            const events = useEvents()

            events.on('downloads:ready', (data: unknown) => {
                const event = data as DownloadEntry
                this.addOrUpdate({
                    downloadKey: event.downloadKey,
                    filename: event.filename,
                    expiresAt: event.expiresAt,
                })
            })

            events.on('downloads:expired', (data: unknown) => {
                const event = data as { downloadKey: string }
                this.remove(event.downloadKey)
            })

            await this.fetchDownloads()
        },

        async fetchDownloads(): Promise<void> {
            const entries = await $fetch<DownloadEntry[]>('/api/me/downloads')
            this.downloads = entries
        },

        addOrUpdate(entry: DownloadEntry): void {
            const existingIndex = this.downloads.findIndex((d) => d.downloadKey === entry.downloadKey)
            if (existingIndex === -1) {
                this.downloads.push(entry)
            } else {
                this.downloads[existingIndex] = entry
            }
        },

        remove(downloadKey: string): void {
            this.downloads = this.downloads.filter((d) => d.downloadKey !== downloadKey)
        },
    },
})
